import React, { useState, useContext } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import image from "assets/img/background.jpg";
import { useSelector, useDispatch } from "react-redux";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import AlertDialog from '../components/AlertDialog';
import CountrySelect from '../components/CountrySelect';
import {Select, MenuItem} from '@material-ui/core';
import {
  language,
  defaultCountry,
  appConfig
} from 'config';
import { FirebaseContext } from 'common';

const useStyles = makeStyles(styles);

export default function Login(props) {
  const { api } = useContext(FirebaseContext);
  const {
    authClear,
    authRegister,
    authUserExist,
    authReferer
  } = api;

  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    email: '',
    mobile: '',
    password: '',
    first_name: '',
    last_name: '',
    role: 'subscriber',
    referrer_code: '',
    referrer_id: '',
    app_mode: appConfig.defaultMode 
  });

  const [alert, setAlert] = useState({ open: false, msg: '' });
  const [countryCode, setCountryCode] = useState(defaultCountry);
  const [mobileNoCountry, setMmobileNoCountry] = useState('');
  const [appMode, setappMode] = useState(appConfig.defaultMode);
  const modedata = useSelector(state => state.modeState.modes);
  const classes = useStyles();
  const { ...rest } = props;

  const onInputChange = (event) => {
    setState({ ...state, [event.target.id]: event.target.value })
  }

  const handleModeSelect = (event) => {
    setappMode(event.target.value);
    setState({
      ...state, app_mode: event.target.value,
    });
  };

  const validateMobile = () => {
    let mobileValid = true;
    let pattern = new RegExp(/^[0-9\b]+$/);
    if (!pattern.test(mobileNoCountry)) {
      mobileValid = false;
    } else if (mobileNoCountry.length < 9 || mobileNoCountry.length > 10 ) {
      mobileValid = false;
    }
    console.log('Number is valid: ' + mobileValid);
    return mobileValid;
  }

  const validatePassword = (complexity) => {
    let passwordValid = true;
    const regx1 = /^([a-zA-Z0-9@*#]{8,15})$/
    const regx2 = /(?=^.{6,10}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])(?!.*\s).*$/
    if (complexity === 'any') {
      passwordValid = state.password.length >= 1;
      if (!passwordValid) {
        setAlert({ open: true, msg: language.error_password_blank })
      }
    }
    else if (complexity === 'alphanumeric') {
      passwordValid = regx1.test(state.password);
      if (!passwordValid) {
        setAlert({ open: true, msg: language.error_password_basic })
      }
    }
    else if (complexity === 'complex') {
      passwordValid = regx2.test(state.password);
      if (!passwordValid) {
        setAlert({ open: true, msg: language.error_password_complex })
      }
    }
    return passwordValid
  }

  const handleRegister = (e) => {
    e.preventDefault();
    //eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (state.first_name.length > 0 && state.last_name.length > 0) {
      if (re.test(state.email)) {
        if (validatePassword('alphanumeric')) {
          if (validateMobile()) {
            authUserExist(state).then((res) => {
              if (res.subscribers && res.subscribers.length > 0) {
                setAlert({ open: true, msg: language.error_exists });
                setTimeout(()=>{
                  props.history.push('/login');
                },2000);
              }
              else if(res.error){
                setAlert({ open: true, msg: res.error })
              } else {
                if (state.referrer_code && state.referrer_code.length > 0) {
                  authReferer(state.referrer_code).then((referralInfo) => {
                    if (referralInfo.uid) {
                      authRegister({...state, referrer_id: referralInfo.uid}).then((res)=>{
                        if(res.uid){
                          setAlert({ open: true, msg: language.output_register_success });
                          setTimeout(()=>{
                            props.history.push('/login');
                          },3000);
                        }else{
                          setAlert({ open: true, msg: language.error_insufficient });
                        }
                      })
                    } else {
                      setAlert({ open: true, msg: language.error_invalid_referrer });
                    }
                  }).catch((error) => {
                    setAlert({ open: true, msg: language.error_invalid_referrer });
                  });
                } else {
                  authRegister(state).then((res)=>{
                    if(res.uid){
                      setAlert({ open: true, msg: language.output_register_success });
                      setTimeout(()=>{
                        props.history.push('/login');
                      },3000);
                    } else {
                      if(res.error){
                        setAlert({ open: true, msg: res.error })
                      } else {
                        setAlert({ open: true, msg: language.error_insufficient });
                      }
                    }
                  })
                }
              }
            });
          } else {
            setAlert({ open: true, msg: language.error_mobile });
          }
        }
      } else {
        setAlert({ open: true, msg: language.error_email });
      }
    } else {
      setAlert({ open: true, msg: language.error_try_again });

    }
  };

  const alertClose = (e) => {
    e.preventDefault();
    setAlert({ open: false, msg: '' });
    if (auth.error.flag) {
      dispatch(authClear());
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    props.history.push('/login');
  };

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div id="sign-in-button" />
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <form className={classes.form}>
                  <Paper square className={classes.root} style={{ paddingTop: 20, borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                    <Tabs
                      value={0}
                      variant="fullWidth"
                      indicatorColor="primary"
                      textColor="inherit"
                      aria-label="switch login type"
                    >
                      <Tab disabled={true} icon={<EmailIcon />} label={language.output_register_email} aria-label="email" />
                    </Tabs>
                  </Paper>
                  <CardBody>
                    {modedata?
                      <Select
                        id="appMode"
                        value={appMode}
                        onChange={handleModeSelect}
                      >
                      <MenuItem value={language.mode_app} key={language.mode_app}>
                        {language.mode_app}
                      </MenuItem>
                        {
                          modedata.map((modes) =>
                            <MenuItem key={modes.name} value={modes.name}>
                                {modes.name} {language.word_mode}
                            </MenuItem>
                          )
                        }
                      </Select>
                    :null}
                    <CustomInput
                      labelText={language.subscriber_first_name}
                      id="first_name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PermIdentityIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                      onChange={onInputChange}
                      value={state.first_name}
                    />
                    <CustomInput
                      labelText={language.subscriber_last_name}
                      id="last_name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PermIdentityIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                      onChange={onInputChange}
                      value={state.last_name}
                    />
                    <CustomInput
                      labelText={language.subscriber_email}
                      id="email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "email",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                      onChange={onInputChange}
                      value={state.email}
                    />
                    <CustomInput
                      labelText={language.password}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "password",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: "off"
                      }}
                      onChange={onInputChange}
                      value={state.password}
                    />
                    {appConfig.showcountryList ?   // COUNTRY
                      <CountrySelect
                        value={countryCode}
                        onChange={
                          (object, value) => {
                            setCountryCode(value);
                            let formattedNum = mobileNoCountry.replace(/ /g, '');
                            formattedNum = formattedNum.replace(/-/g, '');
                            formattedNum = "+" + value.phone + formattedNum.substr(-9);
                            setState({ ...state, mobile: formattedNum })
                          }
                        }
                        style={{ paddingTop: 20 }}
                        disabled={state.verificationId ? true : false}
                      />
                      : null}
                    <CustomInput
                      labelText={language.subscriber_mobile + ' ' + language.input_mobile_format}
                      id="mobile"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        disabled: state.verificationId ? true : false,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                      onChange={
                        (event) => {
                          setMmobileNoCountry(event.target.value)
                          let formattedNum = event.target.value.replace(/ /g, '');
                          formattedNum = formattedNum.replace(/-/g, '');
                          formattedNum = "+" + countryCode.phone + formattedNum.substr(-9);
                          setState({ ...state, mobile: formattedNum })
                        }
                      }
                      value={mobileNoCountry}
                    />
                    <CustomInput    // REFERRAL BONUS
                      labelText={language.input_referrer_code}
                      id="referrer_code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <AttachMoneyIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                      onChange={onInputChange}
                      value={state.referrer_code}
                    />
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleRegister}>
                      {language.input_register}
                    </Button>
                    <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleBack}>
                      {language.input_back}
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
        <AlertDialog open={alert.open} onClose={alertClose}>{alert.msg}</AlertDialog>
      </div>
    </div>
  );
}
